import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp } from "lucide-react";

export default function LiveTicker() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let cancelled = false;
    const pull = () =>
      api
        .get("/arcade/live-winners", { params: { limit: 20 } })
        .then((r) => !cancelled && setRows(r.data?.winners || []))
        .catch(() => {});
    pull();
    const t = setInterval(pull, 6000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, []);
  if (rows.length === 0) return null;
  const doubled = [...rows, ...rows];
  return (
    <div
      className="relative overflow-hidden rounded-full border border-emerald-500/20 bg-gradient-to-r from-emerald-500/5 via-magenta/5 to-emerald-500/5 py-2 mb-6"
      data-testid="live-ticker"
    >
      <div className="flex items-center gap-6 whitespace-nowrap marquee-track">
        {doubled.map((w, i) => (
          <div
            key={`${i}-${w.user || w.loginid || "x"}`}
            className="flex items-center gap-2 text-sm text-white/80"
            data-testid={`ticker-row-${i}`}
          >
            <TrendingUp className="h-3.5 w-3.5 text-emerald-400 shrink-0" />
            <span className="text-emerald-400 font-mono-naevo">+${(w.payout ?? w.profit ?? 0).toFixed(2)}</span>
            <span className="text-white/50">·</span>
            <span className="text-white/90">{w.user || w.handle || `trader_${(w.loginid || "").slice(-4)}`}</span>
            <span className="text-white/50">·</span>
            <span className="text-xs text-white/50 uppercase tracking-wider">{w.game || w.symbol || "trade"}</span>
            <span className="mx-4 text-white/20">•</span>
          </div>
        ))}
      </div>
    </div>
  );
}
